"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// 增强原生getItem、setItem方法
var storage = {
  getItem: function getItem(key) {
    var data = localStorage.getItem(key); // 默认空数组 方便后续插入

    return data ? JSON.parse(data).value : [];
  },
  setItem: function setItem(key, value) {
    return localStorage.setItem(key, JSON.stringify({
      value: value
    }));
  }
};
var _default = storage;
exports.default = _default;